import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c126ac8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mail" }
const _hoisted_2 = { "data-test": "msg1" }
const _hoisted_3 = {
  class: "mail-text",
  "data-test": "msg2"
}

import * as log from '@/model/util/log/Logger'


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailDisp',
  props: {
  // メールアドレス
  mail: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

log.trace('EmailDisp setup start.')

// プロパティ定義


log.trace('EmailDisp setup end.')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('body.entry.message.send3')), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(props.mail), 1)
  ]))
}
}

})